<template>
    <BaseContainer>
        <span slot="principal">
            <v-content class="pr-2 pl-2">
                <v-toolbar class="ma-2" style="border-radius: 30px;">
                    <v-btn icon link to="/">
                        <v-icon>mdi-arrow-left</v-icon>
                    </v-btn>
                    <v-spacer/>
                    <v-toolbar-title v-show="$vuetify.breakpoint.mdAndUp">Acompanhamento</v-toolbar-title>
                    <v-spacer/>
                    <v-text-field
                        @keypress.enter="aplicar"
                        dense
                        outlined
                        single-line
                        hide-details
                        v-model="search"
                        label="Pesquise.."
                        append-icon="mdi-magnify"
                    />
                    <v-spacer/>

                    <PredefinicoesMenu
                        :itens="predefinicoes"
                        :ativa-id="ativaId"
                        :sujo="sujo"
                        :nome-em-uso="nomeEmUso"
                        @aplicar="aplicarPredefinicao"
                        @padrao="aplicarPadrao"
                        @salvar="salvarPredefinicao"
                        @salvar-como="criarPredefinicao"
                        @renomear="renomearPredefinicao"
                        @duplicar="duplicarPredefinicao"
                        @remover="removerPredefinicao"
                    />

                    <ColunasMenu v-model="colunas" :catalogo="catalogoColunas"/>

                    <FiltrosMenu
                        v-model="filtros"
                        :catalogo="catalogoFiltros"
                        @aplicar="aplicar"
                    />

                    <PeriodoFilter
                        :key="periodoKey"
                        v-model="periodo"
                        @update="aplicar"
                    />
                </v-toolbar>

                <div
                    v-if="chips.length"
                    class="d-flex flex-wrap align-center px-4 pb-2"
                >
                    <v-chip
                        v-for="chip in chips"
                        :key="chip.chave"
                        class="mr-2 mb-1"
                        small
                        close
                        @click:close="removerFiltro(chip.chave)"
                    >
                        <span class="font-weight-medium mr-1">{{ chip.titulo }}:</span>
                        {{ chip.texto }}
                    </v-chip>

                    <v-btn text x-small class="mb-1" @click="limparFiltros">
                        Limpar tudo
                    </v-btn>
                </div>

                <v-card elevation="2" class="ma-1">
                    <v-card-text>
                        <v-data-table
                            fixed-header
                            :headers="headers"
                            :items="dados"
                            :mobileBreakpoint="0"
                            :loading="loading"
                            :height="alturaTabela"
                            :disable-pagination="true"
                            :hide-default-footer="true"
                            :options.sync="options"
                            :custom-sort="manterOrdemDoServidor"
                        >
                            <template v-slot:no-data>
                                <div class="py-8 text-center grey--text">
                                    <v-icon large color="grey">mdi-filter-remove-outline</v-icon>
                                    <div class="mt-2">Nenhuma empresa para os filtros atuais.</div>
                                    <v-btn
                                        v-if="chips.length"
                                        text
                                        small
                                        color="primary"
                                        class="mt-1"
                                        @click="limparFiltros"
                                    >
                                        Limpar filtros
                                    </v-btn>
                                </div>
                            </template>

                            <template v-slot:item.database="{ item }">
                                {{ `emp_${item.database}` }}
                            </template>

                            <template v-slot:item.fantasia="{ item }">
                                <v-tooltip bottom :disabled="!item.bloqueio_motivo">
                                    <template v-slot:activator="{ on, attrs }">
                                        <span
                                            v-bind="attrs"
                                            v-on="on"
                                            :class="{ 'red-color': !!item.bloqueio_motivo }"
                                            :style="item.bloqueio_motivo ? 'cursor: help;' : ''"
                                        >{{ item.fantasia }}</span>
                                    </template>
                                    <div v-if="item.bloqueio_motivo">
                                        <div class="font-weight-bold">{{ item.bloqueio_motivo.titulo }}</div>
                                        <div class="text-caption">{{ item.bloqueio_motivo.detalhe }}</div>
                                    </div>
                                </v-tooltip>
                            </template>

                            <template v-slot:item.whatsapp="{ item }">
                                <v-menu offset-y>
                                    <template v-slot:activator="{ on, attrs }">
                                        <div
                                            style="cursor: pointer; display: inline-flex; align-items: center;"
                                            v-bind="attrs"
                                            v-on="on"
                                        >
                                            <v-icon color="green" small>mdi-whatsapp</v-icon>&nbsp;
                                        </div>
                                    </template>

                                    <v-list dense>
                                        <v-list-item @click="copyWhatsapp(item.whatsapp)">
                                            <v-list-item-icon>
                                                <v-icon small>mdi-content-copy</v-icon>
                                            </v-list-item-icon>
                                            <v-list-item-content>
                                                <v-list-item-title>Copiar WhatsApp</v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>

                                        <v-list-item
                                            :disabled="!item.assinatura_whatsapp"
                                            @click="copyWhatsapp(item.assinatura_whatsapp)"
                                        >
                                            <v-list-item-icon>
                                                <v-icon small>mdi-content-copy</v-icon>
                                            </v-list-item-icon>
                                            <v-list-item-content>
                                                <v-list-item-title>Copiar WhatsApp da Assinatura</v-list-item-title>
                                                <v-list-item-subtitle v-if="!item.assinatura_whatsapp">
                                                    Não informado
                                                </v-list-item-subtitle>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-list>
                                </v-menu>
                            </template>

                            <template v-slot:item.created_at="{ item }">
                                {{ formatDate(item.created_at, 'DD/MM') }}
                            </template>

                            <template v-slot:item.dominio="{ item }">
                               <div @click="abrirCardapio(item.dominio)" style="cursor: pointer;">
                                    <v-icon small>mdi-open-in-new</v-icon>&nbsp;
                                    <u>{{ item.dominio }}</u>
                                </div>
                            </template>

                            <template v-slot:item.assinatura_id="{ item }">
                                <v-icon
                                    :color="getSubscriptionColor(item)"
                                    small
                                >mdi-circle</v-icon>&nbsp;
                               <div @click="editar(item)" style="cursor: pointer; display: inline;">
                                    <u>{{ item.assinatura_id }}</u>
                                </div>
                            </template>

                            <template v-slot:item.ativo="{ item }">
                                <v-chip class="ma-2" :color="item.ativo ? 'green' : 'red'" text-color="white">
                                    {{ item.ativo ? 'Ativo' : 'Inativo' }}
                                </v-chip>
                            </template>

                            <template v-slot:item.assinatura_emissao="{ item }">
                                {{ formatDate(item.assinatura_emissao) }}
                            </template>

                            <template v-slot:item.data_ultimo_pedido="{ item }">
                                <v-tooltip bottom :disabled="!isDateOlderThan5Days(item)">
                                    <template v-slot:activator="{ on, attrs }">
                                        <span
                                            v-bind="attrs"
                                            v-on="on"
                                            :class="{ 'red-color': isDateOlderThan5Days(item) }"
                                            :style="isDateOlderThan5Days(item) ? 'cursor: help;' : ''"
                                        >{{ formatDate(item.data_ultimo_pedido) }}</span>
                                    </template>
                                    <span>{{ textoUltimoPedido(item) }}</span>
                                </v-tooltip>
                            </template>

                            <template v-slot:item.trial_started_at="{ item }">
                                {{ formatDate(item.trial_started_at, 'DD/MM/YYYY') }}
                            </template>

                            <template v-slot:item.implementacao="{ item }">
                                <v-select
                                    :disabled="!checkPermission('zapercontrol_acompanhamento_criação_atualizar')"
                                    @change="updateSetupInfo(item.id, 'implementacao', $event)"
                                    v-model="item.setup_info.implementacao"
                                    :items="status"
                                    style="width: 140px;"
                                    outlined
                                    dense
                                    hide-details
                                    :class="getStatusSelectClass(item, 'implementacao')"
                                />
                                <v-chip
                                    v-if="seloCardapioIa(item.setup_info)"
                                    :to="`/cardapios-ia?busca=${item.id}`"
                                    :color="seloCardapioIa(item.setup_info).cor"
                                    x-small
                                    label
                                    outlined
                                    class="mt-1"
                                >
                                    <v-icon x-small left>{{ seloCardapioIa(item.setup_info).icone }}</v-icon>
                                    {{ seloCardapioIa(item.setup_info).texto }}
                                </v-chip>
                            </template>

                            <template v-slot:item.conexao_whatsapp="{ item }">
                                <v-icon :color="item.setup_info.conexao_whatsapp ? 'green' : 'red'">
                                    mdi-check-circle
                                </v-icon>
                            </template>

                            <template v-slot:item.impressora="{ item }">
                                {{ rotulo('impressora', item.setup_info.impressora) }}
                            </template>

                            <template v-slot:item.configuracao_impressora="{ item }">
                                <v-select
                                    :disabled="!checkPermission('zapercontrol_acompanhamento_configuracao_impressora_atualizar')"
                                    @change="updateSetupInfo(item.id, 'configuracao_impressora', $event)"
                                    v-model="item.setup_info.configuracao_impressora"
                                    :items="status"
                                    outlined
                                    dense
                                    hide-details
                                    style="width: 140px;"
                                    :class="getStatusSelectClass(item, 'configuracao_impressora')"
                                />
                            </template>

                            <template v-slot:item.dispositivos="{ item }">
                                <v-icon :color="getCellPhoneColor(item)">mdi-cellphone</v-icon>
                                <v-icon :color="getLaptopColor(item)">mdi-laptop</v-icon>
                            </template>

                            <template v-slot:item.chave_pix="{ item }">
                                <v-icon :color="item.chave_pix ? 'green' : 'red'">
                                    mdi-check-circle
                                </v-icon>
                            </template>

                            <template v-slot:item.pix_automatizado="{ item }">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon
                                            v-bind="attrs"
                                            v-on="on"
                                            :color="item.pix_automatizado ? 'green' : 'red'"
                                        >mdi-check-circle</v-icon>
                                    </template>
                                    <span>
                                        {{ item.pix_automatizado
                                            ? 'Mercado Pago conectado'
                                            : 'Mercado Pago não conectado' }}
                                    </span>
                                </v-tooltip>
                            </template>

                            <template v-slot:item.cadastro_entregador="{ item }">
                                <span v-if="!item.metricas_ate" class="grey--text">—</span>
                                <v-icon v-else :color="item.setup_info.cadastro_entregador ? 'green' : 'red'">
                                    mdi-check-circle
                                </v-icon>
                            </template>

                            <template v-slot:item.tipo_taxa_entrega="{ item }">
                                <span>{{ rotulo('tipo_taxa_entrega', item.setup_info.tipo_taxa_entrega) }}</span>
                            </template>

                            <template v-slot:header.pedidos_ultimos_7_dias_count="{ header }">
                                {{ header.text }}
                                <span v-if="metricasAte" class="text-caption grey--text">até {{ metricasAte }}</span>
                            </template>

                            <template v-slot:item.pedidos_ultimos_7_dias_count="{ item }">
                                <span v-if="!item.metricas_ate" class="grey--text">—</span>
                                <span v-else>{{ item.setup_info.pedidos_ultimos_7_dias_count }}</span>
                            </template>

                            <template v-slot:header.faturamento_ultimos_30_dias="{ header }">
                                {{ header.text }}
                                <span v-if="metricasAte" class="text-caption grey--text">até {{ metricasAte }}</span>
                            </template>

                            <template v-slot:item.faturamento_ultimos_30_dias="{ item }">
                                <span v-if="!item.metricas_ate" class="grey--text">—</span>
                                <span v-else>R$ {{ formatPrice(item.setup_info.faturamento_ultimos_30_dias) }}</span>
                            </template>

                            <template v-slot:item.configuracao_taxa_entrega="{ item }">
                                <v-select
                                    :disabled="!checkPermission('zapercontrol_acompanhamento_configuracao_taxa_entrega_atualizar')"
                                    @change="updateSetupInfo(item.id, 'configuracao_taxa_entrega', $event)"
                                    v-model="item.setup_info.configuracao_taxa_entrega"
                                    :items="status"
                                    style="width: 140px;"
                                    outlined
                                    dense
                                    hide-details
                                    :class="getStatusSelectClass(item, 'configuracao_taxa_entrega')"
                                />
                            </template>

                            <template v-slot:item.horarios="{ item }">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon
                                            color="grey"
                                            v-bind="attrs"
                                            v-on="on"
                                        >
                                        mdi-information
                                        </v-icon>
                                    </template>
                                    <span>{{ item.setup_info.horarios }}</span>
                                </v-tooltip>
                            </template>

                            <template v-slot:item.observacoes="{ item }">
                                <v-menu
                                    :value="menu[item.id]"
                                    :close-on-content-click="false"
                                    :nudge-width="250"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn :disabled="!checkPermission('zapercontrol_acompanhamento_menu_observacoes')" icon v-bind="attrs" v-on="on">
                                            <v-icon>mdi-format-list-bulleted</v-icon>
                                            <v-badge
                                                v-if="item.setup_info.observacoes && item.setup_info.observacoes.length"
                                                color="green"
                                                :content="item.setup_info.observacoes.length"
                                            />
                                        </v-btn>
                                    </template>
                                    <v-card>
                                        <v-card-title>
                                            <v-spacer/>
                                                Observações
                                            <v-spacer/>
                                        </v-card-title>

                                        <v-divider/>

                                        <v-card-text>
                                            <div style="height: 400px; overflow-x: auto;">
                                                <div v-for="(obs, i) in item.setup_info.observacoes" :key="i" class="my-2">
                                                    {{ obs.user_name }} em <i>{{ formatDate(obs.created_at) }}</i>
                                                    <br>
                                                    <b>{{ obs.text }}</b>
                                                    <v-divider/>
                                                </div>
                                            </div>

                                            <div class="mt-2">
                                                <v-textarea
                                                    label="Adcionar observação..."
                                                    v-model="observacao"
                                                    rows="1"
                                                    hide-details
                                                    outlined
                                                    dense
                                                />

                                                <v-btn
                                                    :disabled="!checkPermission('zapercontrol_acompanhamento_observacoes_adicionar')"
                                                    @click="addObservacao(item.id)"
                                                    :loading="obsLoading"
                                                    color="primary"
                                                    class="mt-2"
                                                    block
                                                >
                                                    <v-icon>mdi-content-save</v-icon>
                                                    Salvar
                                                </v-btn>
                                            </div>
                                        </v-card-text>
                                    </v-card>
                                </v-menu>
                            </template>
                        </v-data-table>
                        <Paginate v-model="pagination" @input="consultar"/>
                    </v-card-text>
                </v-card>
            </v-content>
        </span>
    </BaseContainer>
</template>

<script>
import BaseContainer from '@/components/BaseContainer';
import Paginate from '@/components/Paginate';
import PeriodoFilter from '@/components/PeriodoFilter';
import ColunasMenu from '@/components/ColunasMenu';
import FiltrosMenu from '@/components/FiltrosMenu';
import PredefinicoesMenu from '@/components/PredefinicoesMenu';
import catalogoColunas, { coluna, colunasPadrao, normalizarColunas } from './colunas';
import catalogoFiltros, { aplicarParams, chipsAtivos, filtrosPadrao, normalizarFiltros, rotulo } from './filtros';
import { criarRepositorio, mesmoEstado } from '@/utils/listaPredefinicoes';
import { seloAcompanhamento } from '../cardapios-ia/situacoes';
import { mapState } from 'vuex';

const CHAVE_PREDEFINICOES = 'zaper-control-acompanhamento-views';
const CHAVE_FORMATO_ANTIGO = 'zaper-control-acompanhamento-filters';

const repo = criarRepositorio(CHAVE_PREDEFINICOES);

/**
 * Períodos relativos ("Últimos 7 dias") recalculam as datas a cada abertura, então comparar
 * start/end acusaria "alterações não salvas" só porque o dia virou. O que identifica o período
 * é o rótulo — exceto no Personalizado, onde as datas são a própria escolha.
 */
function chavePeriodo(periodo) {
    if (!periodo || !periodo.periodo) {
        return '';
    }

    return periodo.periodo === 'Personalizado'
        ? `Personalizado|${periodo.start}|${periodo.end}`
        : periodo.periodo;
}

export default {
    name: 'Acompanhamento',

    components: {
        Paginate,
        BaseContainer,
        PeriodoFilter,
        ColunasMenu,
        FiltrosMenu,
        PredefinicoesMenu,
    },

    data: () => ({
        catalogoColunas,
        catalogoFiltros,
        periodo: {},
        periodoKey: 0,
        search: '',
        observacao: '',
        obsLoading: false,
        menu: {},
        loading: false,
        dados: [],
        filtros: filtrosPadrao(),
        colunas: colunasPadrao(),
        predefinicoes: [],
        ativaId: null,
        options: { sortBy: [], sortDesc: [] },
        ultimaOrdenacao: JSON.stringify([[], []]),
        pagination: {
            current_page: 1,
            last_page: 1,
            total: 0,
        },
        status: [
            {
                value: 'pendente',
                text: 'Pendente',
            },
            {
                value: 'aguardando',
                text: 'Aguardando',
            },
            {
                value: 'impressora_indicada',
                text: 'Impressora Indicada',
            },
            {
                value: 'agendado',
                text: 'Agendado',
            },
            {
                value: 'concluido',
                text: 'Concluído',
            },
        ],
    }),

    computed: {
        ...mapState([
            'usuario',
        ]),

        headers() {
            return this.colunas
                .map(valor => coluna(valor))
                .filter(Boolean)
                .map(c => ({
                    text: c.text,
                    value: c.value,
                    sortable: !!c.sortable,
                }));
        },

        chips() {
            return chipsAtivos(this.filtros);
        },

        metricasAte() {
            const dias = this.dados.map(d => d.metricas_ate).filter(Boolean).sort();

            return dias.length ? this.moment(dias[dias.length - 1]).format('DD/MM') : '';
        },

        alturaTabela() {
            return this.$vuetify.breakpoint.height - (this.chips.length ? 270 : 230);
        },

        // O que uma predefinição guarda. `search` e página ficam de fora de propósito: são
        // navegação do momento, não a definição do recorte.
        estadoAtual() {
            return {
                colunas: this.colunas,
                filtros: this.filtros,
                periodo: this.periodo,
            };
        },

        predefinicaoAtiva() {
            return this.predefinicoes.find(p => p.id === this.ativaId) || null;
        },

        sujo() {
            const ativa = this.predefinicaoAtiva;

            if (!ativa) {
                return false;
            }

            return !mesmoEstado(
                {
                    colunas: this.colunas,
                    filtros: this.filtros,
                    periodo: chavePeriodo(this.periodo),
                },
                {
                    colunas: normalizarColunas(ativa.colunas),
                    filtros: normalizarFiltros(ativa.filtros),
                    periodo: chavePeriodo(ativa.periodo),
                },
            );
        },

        baseZaperMenu() {
            return (document.URL.indexOf('localhost') !== -1)
                ? 'http://localhost:8082'
                : 'https://app.zapermenu.com.br';
        },

        baseZaperComandas() {
            return (document.URL.indexOf('localhost') !== -1)
                ? 'http://localhost:8081'
                : 'https://admin.zapermenu.com.br';
        },
    },

    watch: {
        options: {
            deep: true,
            handler(novo) {
                const chave = JSON.stringify([novo.sortBy, novo.sortDesc]);

                if (chave === this.ultimaOrdenacao) {
                    return;
                }

                this.ultimaOrdenacao = chave;
                this.aplicar();
            },
        },

        colunas() {
            this.persistirEstado();
        },
    },

    created() {
        this.predefinicoes = repo.listar();
        this.ativaId = repo.ativaId();

        const estado = repo.lerEstado() || this.consumirFormatoAntigo();

        if (estado) {
            this.aplicarEstado(estado);
        }

        this.consultar();
    },

    methods: {
        rotulo,

        seloCardapioIa: seloAcompanhamento,

        getParams() {
            const params = new URLSearchParams();

            // Período só entra quando já foi resolvido: sem a guarda, a primeira carga de um
            // navegador limpo mandaria "undefined" e o banco recusaria a data.
            if (this.periodo && this.periodo.start && this.periodo.end) {
                params.append('start', this.periodo.start);
                params.append('end', this.periodo.end);
            }

            params.append('q', this.search || '');
            params.append('page', this.pagination.current_page);

            aplicarParams(params, this.filtros);

            if (this.options.sortBy.length) {
                params.append('sortField', this.options.sortBy[0]);
                params.append('sortOrder', this.options.sortDesc[0] ? 1 : -1);
            }

            return params.toString();
        },

        consultar() {
            this.loading = true;
            this.dados = [];

            this.persistirEstado();

            const params = this.getParams();

            this.$http.get(`acompanhamento?${params}`)
                .then(resp => {
                    this.pagination = resp.data.meta;
                    this.dados = resp.data.data;
                    this.loading = false;
                })
                .catch(() => {
                    this.notify('Não foi possivel concluir a operação', 'warning');
                }).finally(() => (this.loading = false));
        },

        /**
         * Toda mudança de recorte volta para a primeira página: manter a página anterior deixaria
         * o usuário olhando para um vazio que parece "nenhum resultado".
         */
        aplicar() {
            this.pagination.current_page = 1;
            this.consultar();
        },

        removerFiltro(chave) {
            const padrao = filtrosPadrao();

            this.filtros = { ...this.filtros, [chave]: padrao[chave] };
            this.aplicar();
        },

        limparFiltros() {
            this.filtros = filtrosPadrao();
            this.aplicar();
        },

        // --- predefinições ---

        persistirEstado() {
            repo.salvarEstado({
                colunas: this.colunas,
                filtros: this.filtros,
                periodo: this.periodo,
                search: this.search,
                page: this.pagination.current_page,
            });
        },

        aplicarEstado(estado) {
            this.colunas = normalizarColunas(estado.colunas);
            this.filtros = normalizarFiltros(estado.filtros);

            if (estado.periodo && estado.periodo.periodo) {
                this.periodo = estado.periodo;
                // O PeriodoFilter só lê o v-model ao montar; remontar é o que faz ele recalcular
                // as datas do período restaurado sem mexer na API de um componente compartilhado.
                this.periodoKey++;
            }

            if (estado.search !== undefined) {
                this.search = estado.search;
            }

            if (estado.page) {
                this.pagination.current_page = estado.page;
            }
        },

        recarregarPredefinicoes() {
            this.predefinicoes = repo.listar();
            this.ativaId = repo.ativaId();
        },

        nomeEmUso(nome, ignorarId) {
            return repo.nomeEmUso(nome, ignorarId);
        },

        aplicarPredefinicao(id) {
            const item = repo.obter(id);

            if (!item) {
                return;
            }

            repo.definirAtiva(id);
            this.aplicarEstado(item);
            this.recarregarPredefinicoes();
            this.aplicar();
        },

        aplicarPadrao() {
            repo.definirAtiva(null);
            this.aplicarEstado({
                colunas: colunasPadrao(),
                filtros: filtrosPadrao(),
            });
            this.recarregarPredefinicoes();
            this.aplicar();
        },

        criarPredefinicao(nome) {
            repo.criar(nome, this.estadoAtual);
            this.recarregarPredefinicoes();
            this.notify('Predefinição salva');
        },

        salvarPredefinicao() {
            if (!this.ativaId) {
                return;
            }

            repo.atualizar(this.ativaId, this.estadoAtual);
            this.recarregarPredefinicoes();
            this.notify('Predefinição atualizada');
        },

        renomearPredefinicao(nome) {
            repo.renomear(this.ativaId, nome);
            this.recarregarPredefinicoes();
        },

        duplicarPredefinicao(nome) {
            repo.duplicar(this.ativaId, nome);
            this.recarregarPredefinicoes();
            this.notify('Predefinição duplicada');
        },

        removerPredefinicao(id) {
            repo.remover(id);
            this.recarregarPredefinicoes();
            this.notify('Predefinição excluída');
        },

        /**
         * Converte (uma única vez) o formato anterior, que só guardava busca, período e o
         * checkbox de inadimplentes.
         */
        consumirFormatoAntigo() {
            const bruto = localStorage.getItem(CHAVE_FORMATO_ANTIGO);

            if (!bruto) {
                return null;
            }

            localStorage.removeItem(CHAVE_FORMATO_ANTIGO);

            try {
                const antigo = JSON.parse(bruto) || {};
                const filtros = filtrosPadrao();

                if (antigo.somenteInadimplentes) {
                    filtros.status = ['inadimplentes'];
                }

                return {
                    colunas: colunasPadrao(),
                    filtros,
                    periodo: antigo.periodo,
                    search: antigo.search || '',
                    page: antigo.page || 1,
                };
            } catch (e) {
                return null;
            }
        },

        // --- grid ---

        /**
         * A ordenação é feita no banco (a paginação é server-side). Reordenar no cliente mexeria
         * só nas linhas da página e brigaria com a ordem recebida.
         */
        manterOrdemDoServidor(items) {
            return items;
        },

        updateSetupInfo(id, field, value) {
            const data = {
                id,
                field,
                value,
            };
            this.$http.post(`acompanhamento/update-status`, data)
                .then(resp => {
                    if (resp.data.type === 'warning') {
                        this.notify(resp.data.msg, 'warning');
                        return;
                    }

                    this.notify('Atualizado com sucesso');
                })
                .catch(() => {
                    this.notify('Não foi possivel concluir a operação', 'warning');
                }).finally(() => (this.loading = false));
        },

        addObservacao(id) {
            this.obsLoading = true;

            const data = {
                id,
                value: this.observacao.trim(),
            };

            this.$http.post(`acompanhamento/add-observacao`, data)
                .then(resp => {
                    if (resp.data.type === 'warning') {
                        this.notify(resp.data.msg, 'warning');
                        return;
                    }

                    const index = this.dados.findIndex(e => e.id == id);

                    if (index !== -1) {
                        this.dados[index].setup_info.observacoes.push(resp.data.data);
                        this.observacao = '';
                    }

                    this.notify('Atualizado com sucesso');
                })
                .catch((e) => {
                    console.log(e)
                    this.notify('Não foi possivel concluir a operação', 'warning');
                }).finally(() => (this.obsLoading = false));
        },

        abrirCardapio(route) {
            window.open(`${this.baseZaperMenu}/${route}`);
        },

        editar(row) {
            this.$router.push(`/financeiro/${row.id}`);
        },

        isDateOlderThan5Days(item) {
            if (!item.assinatura_id || !item.data_ultimo_pedido) {
                return false;
            }

            const date = this.moment(item.data_ultimo_pedido);
            const currentDate = this.moment();

            const daysDifference = currentDate.diff(date, 'days');

            return daysDifference >= 5;
        },

        textoUltimoPedido(item) {
            if (!item.data_ultimo_pedido) {
                return 'Nenhum pedido registrado';
            }

            const dias = this.moment().diff(this.moment(item.data_ultimo_pedido), 'days');

            return `Sem pedidos há ${dias} dias`;
        },

        getSubscriptionColor({ last_charge_notification: charge }) {
            if (!charge) {
                return 'white';
            }

            if (['paid', 'settled', 'identified'].includes(charge.status.current)) {
                return 'green';
            }

            if (['new', 'waiting'].includes(charge.status.current)) {
                return 'blue';
            }

            if (['new'].includes(charge.status.current)) {
                return 'yellow';
            }

            if (['unpaid', 'refunded', 'contested', 'canceled', 'expired'].includes(charge.status.current)) {
                return 'red';
            }
        },

        getCellPhoneColor(item) {
            return item.setup_info?.dispositivo_mobile
                ? 'green'
                : 'red';
        },

        getLaptopColor(item) {
            return item.setup_info?.dispositivo_pc
                ? 'green'
                : 'red';
        },

        getStatusSelectClass(item, field) {
            const status = item?.setup_info?.[field];
            const st = status || 'desconhecido';
            return `status-select status-${st}`;
        },

        copyWhatsapp(whats) {
            const phone = whats.replace(/\D/g, '');

            if (navigator.clipboard && window.isSecureContext) {
                navigator.clipboard.writeText(phone)
                    .then(() => {
                        this.notify('Número copiado para a área de transferência');
                    })
                    .catch(() => {
                        this.notify('Não foi possível copiar o número', 'warning');
                    });
            }
        },
    },
}
</script>

<style lang="scss">
.red-color {
    color: red;
}

.theme--light .status-select.status-pendente .v-input__slot {
  background-color: #f9f871 !important;
}
.theme--light .status-select.status-aguardando .v-input__slot {
  background-color: #fbbbf2 !important;
}
.theme--light .status-select.status-agendado .v-input__slot {
  background-color: #bbdefb !important;
}
.theme--light .status-select.status-concluido .v-input__slot {
  background-color: #a9e2a9 !important;
}
.theme--light .status-select.status-desconhecido .v-input__slot {
  background-color: #eeeeee !important;
}
.theme--light .status-select.status-impressora_indicada .v-input__slot {
  background-color: #ffd1a6 !important;
}

/* Tema Dark */
.theme--dark .status-select.status-pendente .v-input__slot {
  background-color: #c0c002 !important;
}
.theme--dark .status-select.status-aguardando .v-input__slot {
  background-color: #7a4970 !important;
}
.theme--dark .status-select.status-agendado .v-input__slot {
  background-color: #486b8b !important;
}
.theme--dark .status-select.status-concluido .v-input__slot {
  background-color: #4a7050 !important;
}
.theme--dark .status-select.status-desconhecido .v-input__slot {
  background-color: #555555 !important;
}
.theme--dark .status-select.status-impressora_indicada .v-input__slot {
  background-color: #8a5a2b !important;
}
</style>
